/**
 * Shared API configuration
 */
export const API_CONFIG = {
  TIMEOUT: 60000,
} as const;
